import React from "react"
import "./page-title.css"

function PageTitle({ title, span, subtitle, reverse }) {
  return (
    <div data-scroll-section className={`${reverse ? "bg-reverse" : ""}`}>
      <div className={`container-fluid page-title-container`}>
        <p>{subtitle}</p>
        <h1 className="serif-2">
          {title} <span className="clr-accent">{span}</span>
        </h1>
      </div>
    </div>
  )
}

export default PageTitle
